
import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';

interface CycleImportHeaderProps {
  isUploading: boolean;
  onBackClick: () => void;
}

const CycleImportHeader: React.FC<CycleImportHeaderProps> = ({ 
  isUploading, 
  onBackClick 
}) => {
  return (
    <div className="mb-6">
      <Button 
        variant="ghost" 
        size="sm" 
        className="mb-4 text-hormony-charcoal hover:text-hormony-coral" 
        onClick={onBackClick}
        disabled={isUploading}
      >
        <ChevronLeft className="mr-1 h-4 w-4" />
        Back to Cycle Tracking
      </Button>
      <h1 className="text-2xl font-bold mb-2 text-hormony-charcoal">Import Cycle History</h1>
      <p className="text-muted-foreground">
        Upload your menstrual cycle history, symptoms, medications, and contraceptive use from Excel or CSV files.
      </p>
    </div>
  );
};

export default CycleImportHeader;
